import { useState, useEffect } from "react";

const features = [
  {
    id: 1,
    title: "24-hour support",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae blandit eu etiam urna odio risus",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
        <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M55.9994 33.1853C56.0095 37.096 55.0958 40.9538 53.3326 44.4446C49.0688 52.9759 40.3516 58.3668 30.8141 58.3705C26.9034 58.3807 23.0456 57.467 19.5549 55.7038L2.66602 61.3334L8.29564 44.4446C6.53247 40.9538 5.61878 37.096 5.62897 33.1853C5.63266 23.6478 11.0236 14.9306 19.5549 10.6668C23.0456 8.90367 26.9034 7.98997 30.8141 8.00008H32.2956C45.0832 8.70565 55.2938 18.9163 55.9994 31.7038V33.1853Z" fill="#FF5533"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M61.3333 27.8513C61.3434 31.762 60.4298 35.6199 58.6666 39.1106C54.4028 47.6419 45.6856 53.0328 36.1481 53.0365C32.2374 53.0467 28.3796 52.133 24.8889 50.3698L8 55.9994L13.6296 39.1106C11.8665 35.6199 10.9528 31.762 10.963 27.8513C10.9666 18.3138 16.3575 9.59666 24.8889 5.33285C28.3796 3.56968 32.2374 2.65599 36.1481 2.6661H37.6296C50.4171 3.37166 60.6278 13.5823 61.3333 26.3699V27.8513Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M25.334 28H26.6673" stroke="#111111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M35.334 28H36.6673" stroke="#111111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M45.334 28H46.6673" stroke="#111111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    id: 2,
    title: "No hidden fees",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae blandit eu etiam urna odio risus",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
        <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M29.3327 8C44.058 8 55.9993 19.9387 55.9993 34.6667C55.9993 49.392 44.058 61.3333 29.3327 61.3333C14.6047 61.3333 2.66602 49.392 2.66602 34.6667C2.66602 19.9387 14.6047 8 29.3327 8Z" fill="#FD4621"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M34.6667 2.66602C49.392 2.66602 61.3333 14.6047 61.3333 29.3327C61.3333 44.058 49.392 55.9993 34.6667 55.9993C19.9387 55.9993 8 44.058 8 29.3327C8 14.6047 19.9387 2.66602 34.6667 2.66602Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24 34.666C24 34.666 28 39.9993 34.6667 39.9993C41.3333 39.9993 45.3333 34.666 45.3333 34.666" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M26.666 21.332H26.6927" stroke="#111111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M42.666 21.332H42.6927" stroke="#111111" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    id: 3,
    title: "Booking flexibility",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae blandit eu etiam urna odio risus",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="61" height="58" viewBox="0 0 61 58" fill="none">
        <path opacity="0.2" d="M25.9993 57.3346C39.9906 57.3346 51.3327 45.9925 51.3327 32.0013C51.3327 18.0101 39.9906 6.66797 25.9993 6.66797C12.0081 6.66797 0.666016 18.0101 0.666016 32.0013C0.666016 45.9925 12.0081 57.3346 25.9993 57.3346Z" fill="#FD4621"/>
        <path d="M59.3327 24.3509V26.6814C59.3263 37.9 51.9412 47.7782 41.1823 50.9591C30.4234 54.1399 18.8537 49.8658 12.7472 40.4544C6.64081 31.0431 7.45235 18.7365 14.7418 10.2084C22.0312 1.68037 34.062 -1.03767 44.3101 3.5283" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M59.332 6.66797L34.7166 30.668L27.332 23.4752" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    id: 4,
    title: "Included transfers",
    description:
      "Lorem ipsum dolor sit amet consectetur. Vitae blandit eu etiam urna odio risus",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="44" viewBox="0 0 60 44" fill="none">
        <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M37.9993 9.33398C41.8841 9.33398 46.1639 9.91536 48.666 15.0482C50.3341 18.4701 51.1681 24.5653 51.1681 33.334H0.666016V9.33398C25.5549 9.33398 37.9993 9.33398 37.9993 9.33398Z" fill="#FD4621"/>
        <path opacity="0.2" d="M8.66536 44.0007C11.6109 44.0007 13.9987 41.6128 13.9987 38.6673C13.9987 35.7218 11.6109 33.334 8.66536 33.334C5.71985 33.334 3.33203 35.7218 3.33203 38.6673C3.33203 41.6128 5.71985 44.0007 8.66536 44.0007Z" fill="#FD4621"/>
        <path opacity="0.2" d="M40.6654 44.0007C43.6109 44.0007 45.9987 41.6128 45.9987 38.6673C45.9987 35.7218 43.6109 33.334 40.6654 33.334C37.7198 33.334 35.332 35.7218 35.332 38.6673C35.332 41.6128 37.7198 44.0007 40.6654 44.0007Z" fill="#FD4621"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M46 1.33398C49.8848 1.33398 54.1646 1.91536 56.6667 7.04818C58.3347 10.4701 59.1688 16.5653 59.1688 25.334H6V1.33398C32.6667 1.33398 46 1.33398 46 1.33398Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.6673 36.0007C19.6128 36.0007 22.0007 33.6128 22.0007 30.6673C22.0007 27.7218 19.6128 25.334 16.6673 25.334C13.7218 25.334 11.334 27.7218 11.334 30.6673C11.334 33.6128 13.7218 36.0007 16.6673 36.0007Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M48.6673 36.0007C51.6128 36.0007 54.0007 33.6128 54.0007 30.6673C54.0007 27.7218 51.6128 25.334 48.6673 25.334C45.7218 25.334 43.334 27.7218 43.334 30.6673C43.334 33.6128 45.7218 36.0007 48.6673 36.0007Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6 14.668H56.6667" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M46 14.6673V1.33398" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24.666 14.6673V1.33398" stroke="#191919" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
];

const FeatureCard = ({ feature, index }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 120 * index);
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div
      className="flex flex-col gap-4 p-6 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300 group"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateX(0)" : "translateX(40px)",
        transition: "opacity 0.6s ease, transform 0.6s ease",
      }}
    >
      {/* Icon */}
      <div className="w-16 h-16 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
        {feature.icon}
      </div>

      {/* Content */}
      <div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
        <p className="text-sm text-gray-500 leading-relaxed">{feature.description}</p>
      </div>
    </div>
  );
};

const FeaturesSection = () => {
  return (
    <section className="pt-10 px-4 sm:px-8 lg:px-20">
      <div className="w-full mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <FeatureCard key={feature.id} feature={feature} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;